import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import styles from './Footer.module.css';
import { FooterControls } from './FooterControls/FooterControls';
import { FooterInfoBlock } from './FooterInfoBlock/FooterInfoBlock';
import { FooterVersion } from './FooterVersion/FooterVersion';

export type FooterProps = {
  background?: 'gray' | 'white';
  className?: string;
};

export const Footer: FunctionComponent<FooterProps> = ({
  background = 'gray',
  className,
}) => {
  return (
    <footer className={cx(styles.root, className)}>
      <div className={cx(styles.container, styles[background])}>
        <div className={styles.content}>
          <FooterControls />
          <FooterInfoBlock />
          <FooterVersion />
        </div>
      </div>
    </footer>
  );
};
